<template>
    <div class="mls-provided-container" :class="theme">
        <div v-if="provided" class="mls-provided" v-html="provided"></div>
    </div>
</template>
<script>
import { mapState } from '@/store/helpers';

import util from '@/common/util';
import { getProviderHtml } from '@/common/house';
import { phoneLoginFormat } from "@/common/format/phone-format.js";

export default {
    i18next: {
        ns: 'md-sold-detail'
    },
    props: {
        theme: {
            type: String
        }
    },
    computed: {

        ...mapState({
            "info": store => store.listingDetail.info || {}
        }),
        
        provided() {
            const agentCellPhone = this.formatPhoneNum(
                this.info.agentCellPhone
            );
            const agentOfficePhone = this.formatPhoneNum(
                this.info.agentOfficePhone
            );
            let data = {
                provided: Object.keys(this.info)?.includes('isOfficeListed') ?
                    this.info.isOfficeListed ? getProviderHtml(this.info.mlsOrg?.template, {
                    ...this.info,
                    agentCellPhone,
                    agentOfficePhone
                }) : this.info.mlsOrg?.template : getProviderHtml(this.info.mlsOrg?.template, {
                    ...this.info,
                    agentCellPhone,
                    agentOfficePhone
                }),
            };
            if (!util.isSSRServer && window.globalHouseDataFormat) {
                window.globalHouseDataFormat(data, 'mls');
            }
            return data.provided;
        }
    },
    methods: {
        formatPhoneNum(value) {
            return phoneLoginFormat(value);
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
.mls-provided-container {

    .mls-provided {
        line-height: 1.5;
    }
    &.standard .mls-provided {
        color: #595e6d;
        font-size: 14px;
        margin-bottom: 40px;
        @include media-600 {
            font-size: 12px;
            margin-bottom: 20px;
        }
    }
    &.template4 .mls-provided {
        color: #bfc9e4;
        font-size: 14px;
        margin-bottom: 30px;
        // padding-right: 300px;
        @include media-600 {
            margin-bottom: 15px;
            padding-right: 0;
        }
    }
    &.template1 .mls-provided {
        font-size: 14px;
        color: #202437;
        margin-bottom: 30px;
        @include media-600 {
            margin-bottom: 20px;
        }
    }
    &.broker {
        margin-bottom: 15px;
        .mls-provided {
            font-size: 14px;
            color: #505050;
            margin-bottom: 15px;
        }
    }
}
</style>
